import {useMutation} from "@tanstack/react-query";
import SingleProductServices from "@/http/api/single-product/SingleProductServices";

export class SingleProductQueryHook extends SingleProductServices {

    useProductItemDataLayer = () => {
        return useMutation({
            mutationFn: (modelId: number) => this.productItemDataLayer(modelId),
            mutationKey: ["productItemDataLayer"],
        })
    }
}